import { useViewportWidth } from '@/hooks/shared';
import { ASSETS_TYPE, FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';
import { Layout } from '../layouts';
import { BaseTabs, TabType } from '@/modules';
import { Icon } from '@/components/shared/display/Icon';
import { IndustryWindowsIcon, TruckPlowIcon, LayerGroupIcon } from '@/assets/Icons';
import { Sites } from '@/components/pages/SitesPage';

// Sites page tabs - direct React composition, no registry
const SITES_PAGE_TABS: TabType[] = [
  {
    id: ASSETS_TYPE.ALL,
    title: 'All',
    tooltip: 'View all assets',
    icon: <Icon icon={LayerGroupIcon} />,
  },
  {
    id: ASSETS_TYPE.FIXED,
    title: 'Fixed',
    tooltip: 'View fixed assets',
    icon: <Icon icon={IndustryWindowsIcon} />,
  },
  {
    id: ASSETS_TYPE.MOBILE,
    title: 'Mobile',
    tooltip: 'View mobile assets',
    icon: <Icon icon={TruckPlowIcon} />,
  },
];

export const SitesPage = () => {
  const { isTablet } = useViewportWidth();

  return (
    <Layout>
      <div className="flex flex-col md:px-8 w-full h-full gap-4 px-2 py-0 max-h-screen">
        <BaseTabs
          tabs={SITES_PAGE_TABS}
          updateUrl={true}
          defaultValue={ASSETS_TYPE.ALL}
          paramAlias={FILTER_PARAMS.ASSETS_TYPE}
          hideTabTriggers={!isTablet}
          renderFixedElement={() => <Sites />}
        />
      </div>
    </Layout>
  );
};
